import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ManageType } from 'src/app/decorators/type-manager-decorator';
import { CNLabo } from 'src/app/models/cnlabo';
import { CNPatient } from 'src/app/models/cnpatient';
import { LaboService, LaboServiceFilter, LaboServiceSubject } from 'src/app/services/labo.service';

@ManageType('LaboTableComponent')
@Component({
  selector: 'app-labo-table',
  templateUrl: './labo-table.component.html',
  styleUrls: ['./labo-table.component.scss']
})
export class LaboTableComponent implements OnInit {

  displayedColumns: string[] = ['labo'];
  public labos = new MatTableDataSource<CNLabo>();
  public subject: LaboServiceSubject;
  private myLocation = 'default';
  private myPatient: CNPatient;
  private myShowPaginator = true;
  private myFilter = LaboServiceFilter.all;

  @ViewChild('paginator', { static: true }) thePaginator;
  @Input() pageSize = 5;

  constructor(public laboservice: LaboService) { }

  ngOnInit(): void {
    this.laboservice.clear.subscribe(flag => {
      console.log('labos cleared');
      if (this.myShowPaginator) {
        this.thePaginator.pageIndex = 0;
      }
    });
  }

  @Input() set location(theLocation: string) {
    this.myLocation = theLocation;
    this.subject = this.laboservice.getSubject(this.myLocation, this.myFilter, this.pageSize);
    this.subject.labos.subscribe(data => {
      this.labos.data = data;
    });
    if (this.myPatient) {
      this.subject.patient = this.myPatient;
    }
  }

  @Input() set paginator(flag: boolean) {
    this.myShowPaginator = flag;
  }

  get paginator(): boolean {
    return this.myShowPaginator;
  }

  @Input() set patient(thePatient: CNPatient) {
    this.myPatient = thePatient;
    if (this.subject) {
      // subject already set, just set patient
      this.subject.clear();
      this.subject.patient = this.myPatient;
    }
  }

  changePage(event: PageEvent): void {
    if (!this.subject) {
      return;
    }
    const newStart = event.pageIndex * event.pageSize;
    if (newStart !== this.subject.start) {
      this.subject.start = newStart;
    }
    if (this.subject.limit !== event.pageSize) {
      this.subject.limit = event.pageSize;
    }
  }

  updated(event: CNLabo) {
    setTimeout(() => {
      this.subject.start = this.subject.start; // Force reload
    });
  }

}
